<template>
  <div v-if="item" class="p-bot-6">
    <WidgetSliderSwiper
      :length="item.slide.length"
      :title="item.sectionTitle"
      :text="item.text"
      class="image-text-link-swiper"
    >
      <template
        v-for="(slide, index) in item.slide"
        :key="index"
        #[`slide-${index}`]
      >
        <ImageTextLinkSwiperSlide :item="slide" />
      </template>
    </WidgetSliderSwiper>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'ImageTextLinkSwiper',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
